import styled from "styled-components";
import { css } from "styled-components";

export const LanguageBoxWrapper = styled.div.attrs((props) => ({}))`
  z-index: ${({ open }) => (open ? "1" : "-1")};
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  flex-wrap: wrap;
  display: flex;
  height: 7rem;
  width: 100%;
  ${({ width }) =>
    width &&
    css`
      max-width: ${({ width }) => width};
    `}

  align-items: center;

  justify-content: center;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "transparent")};
`;
